export const commaSeparatedDigits = (
  value: string | number | null | undefined | unknown,
) => {
  if (!value) return value;
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const removeNonNumeric = (value: string): string =>
  value.toString().replace(/[^0-9]/g, "");

export function formatWithCommas(
  amount: string | number | null | undefined | unknown,
): string {
  if (!amount) return "";

  // remove existing commas
  const sanitized: string = amount.toString().replace(/,/g, "");

  // split integer & decimal
  const [integerPart, decimalPart] = sanitized.split(".");

  if (!integerPart || isNaN(Number(integerPart))) return amount.toString();

  const lastThree: string = integerPart.slice(-3);
  const remaining: string = integerPart.slice(0, -3);

  const formattedInteger: string = remaining
    ? remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree
    : lastThree;

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart.padEnd(2, "0")}`
    : `${formattedInteger}.00`;
}

// Format Price in INR(Inidan Format)
export function fCurrencyInr(
  amount: string | number | null | undefined | unknown,
  defaultValue: string = "",
): string {
  if (!amount) return defaultValue;

  // remove existing commas
  const sanitized: string = amount.toString().replace(/,/g, "");

  // split integer & decimal
  const [integerPart, decimalPart] = sanitized.split(".");

  if (!integerPart || isNaN(Number(integerPart))) return amount.toString();

  const lastThree: string = integerPart.slice(-3);
  const remaining: string = integerPart.slice(0, -3);

  const formattedInteger: string = remaining
    ? remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree
    : lastThree;

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart.padEnd(2, "0")}`
    : `${formattedInteger}.00`;
}

// Format Price in INR(Inidan Format)
export function fCurrencyInrV2(
  amount: string | number | null | undefined | unknown,
  defaultValue: string = "",
): string {
  if (!amount) return "0";

  // remove existing commas
  const sanitized: string = amount.toString().replace(/,/g, "");

  // split integer & decimal
  const [integerPart, decimalPart] = sanitized.split(".");

  if (!integerPart || isNaN(Number(integerPart))) return amount.toString();

  // Check if amount is greater than 0
  const numericAmount = Number(sanitized);
  if (numericAmount <= 0) return "0";

  const lastThree: string = integerPart.slice(-3);
  const remaining: string = integerPart.slice(0, -3);

  const formattedInteger: string = remaining
    ? remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree
    : lastThree;

  const formattedAmount =
    decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart.padEnd(2, "0")}`
      : `${formattedInteger}.00`;

  return `₹ ${formattedAmount}`;
}
